/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smartlab_Settings_Forbidden_DescInputs */

const vi_smartlab_settings_forbidden_desc = /** @type {(inputs: Smartlab_Settings_Forbidden_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng liên hệ quản trị viên để được cấp quyền.`)
};

/**

* @param {Smartlab_Settings_Forbidden_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const smartlab_settings_forbidden_desc = /** @type {((inputs?: Smartlab_Settings_Forbidden_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smartlab_Settings_Forbidden_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_smartlab_settings_forbidden_desc(inputs)
});